/* eslint-disable max-len */
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChatIcon = function ChatIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    enableBackground: "new 0 0 90 90",
    viewBox: "0 0 90 90",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Chat Icon"
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m67.2 9.9v36.2c0 2.7-2.2 4.8-4.8 4.8h-36.1c-1.3 0-2.5.5-3.4 1.4l-11.6 11.7c-3 3-8.2.9-8.2-3.4v-50.6c0-2.7 2.2-4.8 4.8-4.8h54.6c2.6-.1 4.7 2.1 4.7 4.7z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m22.8 62.9v2.6c0 2.7 2.2 4.8 4.8 4.8h36.1c1.3 0 2.5.5 3.4 1.4l11.7 11.7c3 3 8.2.9 8.2-3.4v-50.6c0-2.7-2.2-4.8-4.8-4.8h-4"
      })]
    })]
  });
};

export default /*#__PURE__*/memo(ChatIcon);